"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialSymbolIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const googleFontUrl = "https://fonts.googleapis.com/css2?family=Material+Symbols+Sharp:wght,FILL@200,0";
// Styled component for the icon
const StyledIcon = styled_components_1.default.span `
  @import url(${googleFontUrl});
  font-family: "Material Symbols Sharp";
  color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : "inherit"; }};
  transform: ${(props) => { var _a; return (_a = props.transform) !== null && _a !== void 0 ? _a : ""; }};
  font-size: ${(props) => { var _a; return (_a = props.size) !== null && _a !== void 0 ? _a : "24px"; }};
  line-height: ${(props) => { var _a; return (_a = props.size) !== null && _a !== void 0 ? _a : "24px"; }};
  font-variation-settings: "opsz" 24;
  font-weight: 200;
`;
const MaterialSymbolIcon = ({ name, color, size, transform }) => {
    const getSizePx = (size) => {
        switch (size) {
            case "small":
                return "16px";
            case "medium":
                return "24px";
            case "large":
                return "32px";
            case "xLarge":
                return "48px";
            default:
                return "24px";
        }
    };
    const sizePx = getSizePx(size);
    return (react_1.default.createElement(StyledIcon, { size: sizePx, color: color, transform: transform }, name));
};
exports.MaterialSymbolIcon = MaterialSymbolIcon;
exports.default = exports.MaterialSymbolIcon;
//# sourceMappingURL=MaterialSymbolIcon.js.map